import React from 'react'

import * as cp from '../../../comps'

import ProductViewer from '../Summary/ProductViewer'

import {
  PRODUCT_LINEUP_SECTIONS,
  ProductLineupTile,
  lineupTilePhoto,
} from './productLineupSections'

//@ts-ignore
import styles from './ProductLineup.module.css'

export interface ProductLineupProps {
  company: string
  noPDF?: boolean
}

// Product line-up sheet — Jaron, #development-dpt 2026-08-28 15:48: "Add this
// to report" ... "Above the other comparison you made" (ticket 12925016320).
// Renders right before SalesSlick.tsx so it sits above the
// HomeCam-vs-competitors comparison, and — like SalesSlick — kept off the
// exported PDF (noPDF): Jaron treats the two pages as a pair.
//
// It used to be one composite JPG with % hotspots. Jaron's Oct 8 marks on that
// sheet (ticket 13241344427) asked for it to match the app catalog: numbered
// sections, only products the rep can actually sell, NVR under CCTV, S340 /
// S220 / Indoor S350 / Glass Break added, Keypad next to Smart Panel, and the
// discontinued models out. It is now built from productLineupSections.ts, so
// every tile is a real catalog `type` and opens the Job Summary viewer. The
// third section reads "Smart Home" (how the Job Summary and the contract name
// security_system), not "Alarm" as marked: "alarm" (Monday 12824335937) and
// "security" (T56) are banned on customer surfaces.
export default React.memo<ProductLineupProps>(function ProductLineup({
  company,
  noPDF,
}) {
  const [openTile, setOpenTile] = React.useState<ProductLineupTile | null>(null)
  const openerRef = React.useRef<HTMLButtonElement | null>(null)
  const openProduct = (
    event: React.MouseEvent<HTMLButtonElement>,
    tile: ProductLineupTile,
  ): void => {
    openerRef.current = event.currentTarget
    setOpenTile(tile)
  }
  const closeProduct = (): void => {
    setOpenTile(null)
    openerRef.current?.focus()
  }
  return (
    <cp.PageReport
      autoHeight
      company={company}
      companyBorder
      hPad
      noPDF={noPDF}
    >
      <div className={styles['sheet']}>
        {PRODUCT_LINEUP_SECTIONS.map((section, index) => (
          <section className={styles['section']} key={section.title}>
            <h3 className={styles['header']}>
              <span aria-hidden="true" className={styles['number']}>
                {index + 1}
              </span>
              {section.title}
            </h3>
            <div className={styles['grid']}>
              {section.tiles.map((tile) => (
                <button
                  aria-label={'View ' + tile.label}
                  className={styles['tile']}
                  key={tile.label}
                  onClick={(event) => openProduct(event, tile)}
                  title={'View ' + tile.label}
                  type="button"
                >
                  <span className={styles['photo']}>
                    <img alt="" src={lineupTilePhoto(tile)} />
                  </span>
                  <span className={styles['label']}>{tile.label}</span>
                </button>
              ))}
            </div>
          </section>
        ))}
      </div>
      {openTile && (
        <ProductViewer
          onClose={closeProduct}
          photo={lineupTilePhoto(openTile)}
          type={openTile.type}
        />
      )}
    </cp.PageReport>
  )
})
